import { useContext, useEffect, useState } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/solid";

import { SupportContext } from "../../../hoc/SupportContext";
import { convertDateTimeToFormat, mergeClassNames, convertDateToFormat } from '../../utils/utils';


const statuses = {
    'Billing & Payment Related Issues' : 'text-rose-600',
    'Subscription Purchase / Trial Issues' : 'text-teal-600',
    'Plan Upgrade / Downgrade' : 'text-amber-500',
    'Subscription Cancellation' : 'text-purple-700',
    'Renewal & Auto‑Renewal Issues' : 'text-fuchsia-600',
    'Invoice Related' : 'text-indigo-700',
    'Others' : 'text-green-700',
}

const Tickets = (props) => {
    const { searchText, dateValue } = props;
    const { tickets, handleSingleTicket, fetchData, loading, currentTab, totalPages, currentPage, handleNextPagination, handlePrevPagination, selectedProduct   } = useContext(SupportContext);
    const [debouncedSearch, setDebouncedSearch] = useState(searchText);
    const startKey = dateValue?.startDate ? new Date(dateValue.startDate).getTime() : "";
    const endKey = dateValue?.endDate ? new Date(dateValue.endDate).getTime() : "";
    const productId = selectedProduct?.id;

    useEffect(() => {
        const timer = window.setTimeout(() => setDebouncedSearch(searchText), 500);
        return () => window.clearTimeout(timer);
    }, [searchText]);

    useEffect(() => {
        const term = typeof debouncedSearch === "string" ? debouncedSearch.trim() : "";
        if (term && term.length < 3) return undefined;
        fetchData(currentTab, 1, term, dateValue);
        // Pagination fetches on its own. Search, date, and product each trigger one list call.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedSearch, startKey, endKey, productId]);

    //console.log()

    return (
        <>
        {loading ? <div className='sm:w-1/3 relative bg-white border-b-4 lg:border-b-0 overflow-auto h-[508px] text-gray-500'>Loading</div>: 
    <div className='sm:w-1/3 relative bg-white border-b-4 lg:border-b-0 overflow-auto h-[508px]'>
                                {tickets && tickets.length > 0 ? 
                                <><ul className="divide-y divide-gray-100">
                                {tickets.map((project, index) => (
                                    <li
                                        key={project.id}
                                        className={mergeClassNames(
                                            'flex items-center justify-between gap-x-6 py-5 px-6',
                                            project.selected && 'bg-gray-100' // or whatever "active" styling you want
                                        )}
                                        onClick={() => handleSingleTicket(project.id)}
                                    >
                                        <div className="min-w-0">
                                            <div className="mb-2 flex items-center gap-x-2 text-xs/5 text-gray-500">
                                                <p className="truncate">
                                                    Ticket ID: <span className="font-black">{(project.ticketId)}</span>
                                                </p>
                                                <svg viewBox="0 0 2 2" className="size-0.5 fill-current">
                                                    <circle r={1} cx={1} cy={1} />
                                                </svg>
                                                <p className="whitespace-nowrap">
                                                    <time dateTime={project.created_at}>{convertDateTimeToFormat(project.created_at, 3)}</time>
                                                </p>
                                            </div>
                                            <div className="flex flex-col items-start gap-x-3">
                                                <p className="text-sm/6 font-semibold text-gray-900">{project.title}</p>
                                                <p
                                                    className={mergeClassNames(
                                                        statuses["Others"],
                                                        'mt-0.5 py-0.5 text-xs font-medium',
                                                    )}
                                                >
                                                    {project.support_category?.category_en}
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                                </ul>{/* Pagination Controls */}
                                <div className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3">
                                  <button
                                    className="p-2 text-gray-600 ring-1 rounded-full ring-gray-300 hover:bg-gray-900 hover:text-white hover:border-gray-900 disabled:opacity-50"
                                    disabled={currentPage === 1}
                                    onClick={() => handlePrevPagination(1)}
                                  >
                                    <ChevronLeftIcon className="h-4 w-4" />
                                  </button>
                                  <span className="text-gray-700 text-xs">Page {currentPage} of {totalPages}</span>
                                  <button
                                    className="p-2 text-gray-600 ring-1 rounded-full ring-gray-300 hover:bg-gray-900 hover:text-white hover:border-gray-900 disabled:opacity-50"
                                    disabled={currentPage === totalPages}
                                    onClick={() => handleNextPagination(totalPages)}
                                  >
                                    <ChevronRightIcon className="h-4 w-4" />
                                  </button>
                                </div></> : <div className='text-gray-500'>No Ticket Found!</div>}
                            </div>
                                                    }</>
    )
}
export default Tickets;
